import types from '../mutation-types';
import SharedFilesAPI from '../../api/sharedFiles';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { SHARED_FILE_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  files: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
    isSending: false,
  },
};

export const getters = {
  getSharedFiles(_state) {
    return _state.files;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getSharedFileById: _state => id => {
    return _state.files.find(file => file.id === Number(id));
  },
};

export const actions = {
  get: async function getSharedFiles({ commit }) {
    commit(types.SET_SHARED_FILE_UI_FLAG, { isFetching: true });
    try {
      const response = await SharedFilesAPI.get();
      commit(types.SET_SHARED_FILES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SHARED_FILE_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createSharedFiles({ commit }, obj) {
    commit(types.SET_SHARED_FILE_UI_FLAG, { isCreating: true });
    try {
      const response = await SharedFilesAPI.create(obj);
      AnalyticsHelper.track(SHARED_FILE_EVENTS.CREATE);
      commit(types.ADD_SHARED_FILE, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_SHARED_FILE_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateSharedFiles({ commit }, { id, ...updateObj }) {
    commit(types.SET_SHARED_FILE_UI_FLAG, { isUpdating: true });
    try {
      const response = await SharedFilesAPI.update(id, updateObj);
      AnalyticsHelper.track(SHARED_FILE_EVENTS.UPDATE);
      commit(types.EDIT_SHARED_FILE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SHARED_FILE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteSharedFiles({ commit }, id) {
    commit(types.SET_SHARED_FILE_UI_FLAG, { isDeleting: true });
    try {
      await SharedFilesAPI.delete(id);
      AnalyticsHelper.track(SHARED_FILE_EVENTS.DELETED);
      commit(types.DELETE_SHARED_FILE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SHARED_FILE_UI_FLAG, { isDeleting: false });
    }
  },

  sendFile: async function sendSharedFile({ commit }, { id, ...sendObj }) {
    commit(types.SET_SHARED_FILE_UI_FLAG, { isSending: true });
    try {
      const response = await SharedFilesAPI.sendFile(id, sendObj);
      AnalyticsHelper.track(SHARED_FILE_EVENTS.SEND_FILE);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_SHARED_FILE_UI_FLAG, { isSending: false });
    }
  },
};

export const mutations = {
  [types.SET_SHARED_FILE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_SHARED_FILES]: ($state, files) => {
    $state.files = files;
  },
  [types.ADD_SHARED_FILE]: ($state, file) => {
    $state.files.push(file);
  },
  [types.EDIT_SHARED_FILE]: ($state, file) => {
    const index = $state.files.findIndex(f => f.id === file.id);
    if (index !== -1) {
      $state.files.splice(index, 1, file);
    }
  },
  [types.DELETE_SHARED_FILE]: ($state, id) => {
    $state.files = $state.files.filter(file => file.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
